export default __webpack_public_path__ + "static/media/EM0630.34I-22018_-15004_0.8f18a51c.jpg";